import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import user from './user';
import dashboard from './dashboard';
import paymentMethod from './paymentMethod';
import booking from './booking';

export const reducers = history => combineReducers({
  router: connectRouter(history),
  user,
  dashboard,
  paymentMethod,
  booking,
})


// WEBPACK FOOTER //
// ./src/ducks/index.js